import { buttons, product } from 'copy/copy';
import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslator } from '@bluebeam/react-i18n';
import ProjectRoverHeader from 'components/Icons/ProjectRoverHeader';
import { environmentVars } from 'constants/services';
import BluebeamLogo from 'components/Icons/BluebeamLogo';

const AndroidPage = (): ReactElement => {
  const { translate } = useTranslator(['mobileDetection', 'android']);

  const history = useHistory();

  return (
    <div className="vh100 vw100 bgd-white-2 column items-center justify-center">
      {Boolean(environmentVars.BB_BRANDING) === false ? (
        <ProjectRoverHeader width="224px" />
      ) : (
        <BluebeamLogo width={224} theme="light" />
      )}

      <div className="w80 center pt7 px2">
        <p className="font-size-5">
          {translate('mobileDetection:android:incompatibleDeviceMessage')}
        </p>
        <button className="btn btn-link mt5" onClick={() => history.goBack()}>
          {buttons.dismiss}
        </button>
      </div>
    </div>
  );
};

export default AndroidPage;
